var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 28,
    viewBox: "0 0 18 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 16.368V28H10.7188V16.368H15.4492L16.4336 11.0195H10.7188V9.12734C10.7188 6.3 11.8289 5.21719 14.6945 5.21719C15.5859 5.21719 16.3023 5.23906 16.718 5.28281V0.432031C15.9359 0.21875 14.0219 0 12.9172 0C7.07109 0 4.375 2.76172 4.375 8.71719V11.0195H0.765625V16.368H4.375Z",
    fill: "#131673"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogoBlue);
export default __webpack_public_path__ + "static/media/facebook-logo-blue.3ca654579c61748374875c1f388b0edf.svg";
export { ForwardRef as ReactComponent };